export class AddZipCodeModel{
    zipCodes: any;
    personId: string;
    email?: string;
}